<template>
	<div v-loading="loadingInterface">
		<div class="paramsFormWrapper">
			<el-form style="padding-bottom: 10px; padding-top: 10px" ref="form" :rules="formRules" label-position="top"
				label-width="100px" :model="form">
				<el-form-item id="wf-tour-webhook-url-section" v-if="integrationInterface.name === 'webhookTrigger'" prop="url"
					label="Webhook Callback URL">
					<el-radio-group id="wf-tour-webhook-url-mode" class="webhook-radio-group" v-model="webhookMode">
						<el-radio-button label="Test URL"></el-radio-button>
						<el-radio-button label="Live URL"></el-radio-button>
						<el-radio-button v-if="form.createWebPage" label="Web UI"></el-radio-button>
						<el-radio-button v-if="form.createChatUI" label="Chat UI"></el-radio-button>
					</el-radio-group>
					<el-input id="wf-tour-webhook-url-input" class="callBackUrl" style="margin-top: 20px" v-model="webhookUrl[webhookMode]"
						:disabled="true">
					</el-input>
					<p style="font-size: 10px; word-break: break-word; margin: 0px; line-height: 20px; margin-top: 5px">
						{{ webhookNote }}
						<b style="cursor: pointer" @click="copy(webhookUrl[webhookMode])">Click here to copy</b>
					</p>
					<el-divider class="customDividerWebhook"></el-divider>
				</el-form-item>

				<el-form-item v-if="integrationInterface.name === 'slackTrigger'" prop="url" label="Slack Webhook URL">
					<el-input class="callBackUrl" v-model="slackWebhookUrl" :disabled="true">
					</el-input>
					<p style="font-size: 10px; word-break: break-word; margin: 0px; line-height: 20px; margin-top: 5px">
						Add this URL to your Slack app’s Event Subscriptions to receive events from Slack.
						<b style="cursor: pointer" @click="copy(slackWebhookUrl)">Click here to copy</b>
					</p>
					<el-divider class="customDividerWebhook"></el-divider>
				</el-form-item>
				<span :key="property.name + i" v-for="(property, i) in integrationInterfaceProperties">
					<el-form-item :id="'wf-tour-param-' + property.name" v-if="property.type !== 'hidden' && determineIfToShowField(property.displayOptions, property.matchType)"
						:prop="property.name" :label="property.type === 'notice' ? '' : property.displayName">
						<paramsInterfaceElement @launchNewCredModal="launchNewCredModal" :credentialId="credentialId"
							@credChange="credChange" :form="form" :rootForm="form" :property="property"
							:integrationInterface="integrationInterface" :readOnlyMode="readOnlyMode"
							:workflow="workflow" />
					</el-form-item>
				</span>
			</el-form>
		</div>
		<el-divider class="compressedDivider"></el-divider>
		<el-button id="wf-tour-node-save-btn" :disabled="readOnlyMode || workflow.isActive" v-if="!loadingInterface" @click="save()"
			style="width: 100%; margin-top: 12px" type="primary" :loading="operationInProgress">
			Save Changes
		</el-button>
		<regularModal id="wf-tour-credential-modal" :appendToBody="true" :noBottomPadding="true" top="5vh" width="60%" @close="
			() => {
				showConfigureCredentialsModal = false;
			}
		" :visible="showConfigureCredentialsModal">
			<credentialsConfigurationForm :integration="credentialOptionsForIntegration" />
		</regularModal>
	</div>
</template>

<script>
//All subtypes associated with some interface types
/*
[
  'minValue', !
  'maxValue', !
  'loadOptionsMethod', !
  'loadOptionsDependsOn', !
  'multipleValues', !
  'multipleValueButtonText', !
  'alwaysOpenEditWindow', - won't support
  'password', !
  'editor', !
  'sortable', ! - won't support
  'rows', - Should support
  'loadOptions', !
  'numberPrecision' !
]
*/
import _ from "lodash";
import paramsInterfaceElement from "./paramsInterfaceElement.vue";
import regularModal from "./regularModal.vue";
import credentialsConfigurationForm from "./credentialsConfigurationForm.vue";
import { splitTexByCase } from "../utils/general.js";
import { mapGetters } from "vuex";
import workflowCanvas from "./workflowCanvas.vue";
import { normalizeFields, normalizeCredentialFields } from "../utils/normalizeFields.js";
export default {
	computed: {
		...mapGetters(["returnInputsOutputsForNode"]),
		webhookNote() {
			if (this.webhookMode === "Webpage URL") {
				return "Open this URL in the browser to view your webpage and submit the form to trigger the workflow.";
			} else if (this.webhookMode === "Chat UI URL") {
				return "Open this URL in the browser to view your chat UI.";
			}
			return "Use this callback URL to send data to the webhook.";
		}
	},
	props: { workflow: Object, readOnlyMode: Boolean },
	components: {
		paramsInterfaceElement,
		regularModal,
		credentialsConfigurationForm,
	},
	watch: {
		form: {
			handler() {
				//console.log("Global form watcher", this.form);
			},
			deep: true,
		},
		returnInputsOutputsForNode: function () {
			this.nodeInputs = this.returnInputsOutputsForNode.inputs;
			this.nodeOutputs = this.returnInputsOutputsForNode.outputs;
		},
		'form.createWebPage'(val) {
			if (!val && this.webhookMode === "Webpage URL") {
				this.webhookMode = "Test URL";
			}
		},
		'form.createChatUI'(val) {
			if (!val && this.webhookMode === "Chat UI URL") {
				this.webhookMode = "Test URL";
			}
		}
	},
	data() {
		return {
			webhookMode: "Test URL",
			webhookUrl: {
				"Test URL": "",
				"Live URL": "",
				"Web UI": "",
				"Chat UI": ""
			},
			slackWebhookUrl: "",
			asyncOptionsForMethodName: {},
			loadingInterface: false,
			operationInProgress: false,
			form: {},
			formRules: {},
			integrationInterfaceProperties: [],
			integrationInterface: {},
			originalIntegrationInterface: {},
			credentialId: "",
			showConfigureCredentialsModal: false,
			credentialOptionsForIntegration: {},
			nodeInputs: null,
			nodeOutputs: null,
		};
	},
	methods: {
		launchNewCredModal() {
			this.integrationInterface.nodeDescription.icon = this.integrationInterface.icon;
			this.integrationInterface.nodeDescription.iconMimeType = this.integrationInterface.iconMimeType;
			this.credentialOptionsForIntegration = this.integrationInterface.nodeDescription;
			this.showConfigureCredentialsModal = true;
		},
		credChange(id) {
			this.credentialId = id;
		},
		loadFormData(integration, inputsOutputs) {
			integration.nodeDescription.properties = normalizeFields([...integration.nodeDescription.properties]);
			this.loadingInterface = true;
			this.originalIntegrationInterface = integration;
			this.nodeInputs = inputsOutputs.inputs;
			this.nodeOutputs = inputsOutputs.outputs;
			this.integrationInterface = _.cloneDeep(integration);
			this.credentialId = this.integrationInterface.credentialId;
			if (this.integrationInterface.name === "webhookTrigger") {
				this.webhookUrl = {
					"Test URL": `${process.env.VUE_APP_RUNTIME_ENDPOINT}/test-webhook/${this.workflow.id}/${this.integrationInterface.name}/${this.integrationInterface.id}`,
					"Live URL": `${process.env.VUE_APP_RUNTIME_ENDPOINT}/webhook/${this.workflow.id}/${this.integrationInterface.name}/${this.integrationInterface.id}`,
					"Web UI": `${process.env.VUE_APP_RUNTIME_ENDPOINT}/webpage/${this.workflow.id}/${this.workflow.versionId}/${this.integrationInterface.id}`,
					"Chat UI": `${process.env.VUE_APP_RUNTIME_ENDPOINT}/chat/${this.workflow.id}/${this.workflow.versionId}/${this.integrationInterface.id}`
				};
			}
			if (this.integrationInterface.name === "slackTrigger") {
				this.slackWebhookUrl = `${process.env.VUE_APP_RUNTIME_ENDPOINT}/webhook/${this.workflow.id}/${this.integrationInterface.name}/${this.integrationInterface.id}`
			}
			//Delay of 300 ms to ensure smooth transition of slide out
			setTimeout(() => {
				this.populateFormData();
			}, 300);
		},
		populateFormData() {
			this.$refs.form.resetFields();
			this.form = {};
			this.formRules = {};
			//Assign existing paramter values
			for (let key in this.integrationInterface.parameters) {
				this.$set(this.form, key, this.integrationInterface.parameters[key]);
			}
			this.integrationInterface.nodeDescription.properties.forEach((property) => {
				//Properties need to be set dynamically so they are reactive
				let propertyDefault = property.default;
				if (property.type === "fixedCollection" && Array.isArray(propertyDefault)) {
					//Fixed collections should always be objects
					propertyDefault = {};
				}
				if (property.type === "options" && typeof propertyDefault !== "string") {
					//Options should always be strings
					propertyDefault = "";
					property.default = propertyDefault; //Assign new default to the property itself for sideffect that resets param back to constant
				}
				if (!(property.name in this.form)) {
					this.$set(this.form, property.name, propertyDefault);
				}
				if (property.type !== "hidden" && property.required) {
					this.formRules[property.name] = [
						{ required: true, message: "This field is required", trigger: "change" },
					];
				}
			});
			//Chunk the addition of properties for performance reasons when drawing fields
			const authenticationPropertyExists = this.integrationInterface.nodeDescription.properties.find((each) => {
				return each.name === "authentication";
			});
			this.integrationInterfaceProperties = [];
			for (let i = 0; i < this.integrationInterface.nodeDescription.properties.length; i++) {
				const property = this.integrationInterface.nodeDescription.properties[i];
				setTimeout(() => {
					//Add available creds for single available auth type
					if (
						i === 0 &&
						!authenticationPropertyExists &&
						this.integrationInterface.nodeDescription?.credentials?.length
					) {
						this.addCredentialTypeProperty();
					}
					//Add the individual property
					this.integrationInterfaceProperties.push(property);
					//Add auth type select and available creds for the specific type
					if (
						property.name === "authentication" &&
						this.integrationInterface.nodeDescription?.credentials?.length
					) {
						//If a preset form property is not preset as part of the authentication options then reset the property
						if (
							!property.options
								.map((each) => {
									return each.value;
								})
								.includes(this.form[property.name])
						) {
							this.form[property.name] = "";
						}
						this.addCredentialTypeProperty(property);
					}
					if (i === this.integrationInterface.nodeDescription.properties.length - 1) {
						setTimeout(async () => {
							//If a credential property exists, load all credentials for it
							await this.assignCredentialsToType();
							this.loadingInterface = false;
						}, 500);
					}
				}, 1 * i);
			}
		},
		addCredentialTypeProperty(property) {
			this.integrationInterface.nodeDescription.credentials = normalizeCredentialFields(
				this.integrationInterface.nodeDescription.credentials
			);

			for (let i = 0; i < this.integrationInterface.nodeDescription.credentials.length; i++) {
				const credentialType = this.integrationInterface.nodeDescription.credentials[i];
				let relevantOption;
				if (property) {
					relevantOption = property.options.find((each) => {
						//This is naive for circumstances where visibility depends on on more than one property as other credentials could depend of the same property plus others
						return credentialType.displayOptions.show?.authentication?.includes(each.value);
					});
				}
				const credentialProperty = {
					type: "credentialOptions",
					displayName: `Credential For ${relevantOption ? relevantOption.name : splitTexByCase(credentialType.name)
						}`,
					name: credentialType.name,
					options: [],
					displayOptions: credentialType.displayOptions,
					matchType: credentialType?.matchType || "all", 
				};
				this.integrationInterfaceProperties.push(credentialProperty);
			}
		},
		async assignCredentialsToType() {
			if (this.integrationInterface.nodeDescription?.credentials?.length) {
				for (let i = 0; i < this.integrationInterfaceProperties.length; i++) {
					const property = this.integrationInterfaceProperties[i];
					if (property.type === "credentialOptions") {
						const creds = await this.returnExistingCredentialsForIntegration(property.name);
						property.options = creds;
					}
				}
			}
		},
		async returnExistingCredentialsForIntegration(credType) {
			const result = await this.httpHelper("RUNTIME", "GET", "credentials/returnAllCredentialsOfSpecificType", {
				type: credType,
			});
			if (!result?.error) {
				return result.response || [];
			} else {
				this.$notifyError(this, result.error, "An error occurred when trying to retrieve existing credentials");
			}
		},
		determineIfToShowField(displayOptions, matchType = "all") {
			if (!displayOptions) {
				return true;
			}
			if (displayOptions.show) {
				if (matchType === "any") {
					const anyMatched = Object.keys(displayOptions.show).some((key) => {
						const correspondingPropertyInData = this.form[key];
						const listOfPermissableValues = displayOptions.show[key];
						return listOfPermissableValues.includes(correspondingPropertyInData);
					});
					if (!anyMatched) {
						return false;
					}
				} else {
					for (let key in displayOptions.show) {
						const correspondingPropertyInData = this.form[key];
						const listOfPermissableValues = displayOptions.show[key];
						if (!listOfPermissableValues.includes(correspondingPropertyInData)) {
							return false;
						}
					}
				}
			}
			if (displayOptions.hide) {
				for (let [index, [key]] of Object.entries(Object.entries(displayOptions.hide))) {
					index = parseInt(index);
					const correspondingPropertyInData = this.form[key];
					const listOfValuesNotAllowed = displayOptions.hide[key];
					if (correspondingPropertyInData && !listOfValuesNotAllowed.includes(correspondingPropertyInData)) {
						//Return true to display the property if any one of the hide relevant keys is not set to one of its specified properties
						//Display rule has thus failed, thus we show the field as its the inverse of 'hide'
						return true;
					}
					if (Object.entries(Object.entries(displayOptions.hide)).length - 1 === index) {
						if (listOfValuesNotAllowed.includes(correspondingPropertyInData)) {
							//On the last index if the property of the key in data is set to a specified value then all hide keys have some value that means the field should be hidden
							//Display rule has thus passed, thus we hide the field as this is what the hide rule wishes us to do
							return false;
						}
					}
				}
			}
			return true;
		},
		async save(customSuccessMsg) {
			this.operationInProgress = true;
			let validationPassed = false;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					validationPassed = true;
				}
			});
			if (!validationPassed) {
				this.operationInProgress = false;
				return "validationFail";
			}

			const result = await this.httpHelper("RUNTIME", "PUT", "workflow/updateNodeInWorkflow", {
				workflowId: this.workflow.id,
				versionId: this.workflow.versionId ?? null,
				workflowLastUpdated: this.workflow.updatedAt,
				nodeId: this.integrationInterface.id,
				parameters: this.form,
				credentialId: this.credentialId || "",
				inputs: this.nodeInputs || [],
				outputs: this.nodeOutputs || [],
				inputData: this.integrationInterface.inputData
			});

			setTimeout(() => {
				this.operationInProgress = false;
				if (!result?.error) {
					workflowCanvas.methods.configureNodeInputsOutputs({
						nodeId: this.integrationInterface.id,
						inputs: this.nodeInputs,
						outputs: this.nodeOutputs,
					});
					this.originalIntegrationInterface.credentialId = this.credentialId || "";
					this.originalIntegrationInterface.parameters = _.cloneDeep(this.form);
					this.workflow.updatedAt = result.response.workflowUpdatedAt;
					this.$notify({
						title: "Success",
						message: customSuccessMsg || "Integration config saved",
						type: "success",
						position: "bottom-left",
					});
				} else {
					const rawError = result?.response?.data?.error?.error ?? result?.response?.data?.error ?? result?.error;
					let errorMsg = rawError;
					if (typeof rawError === "string") {
						try {
							const parsed = JSON.parse(rawError);
							errorMsg = parsed.message || rawError;
						} catch (e) {
							console.log(e);
						}
					} else if (rawError?.message) {
						errorMsg = rawError.message;
					}
					this.$notifyError(this, errorMsg);
				}
			}, 500);
		},
		copy(url) {
			this.$copyToClipboard(url);
			this.$notify({
				title: "Success",
				message: "Webhook callback url copied to clipboard",
				type: "success",
				position: "bottom-left",
			});
		},
	},
};
</script>

<style scoped>
.paramsFormWrapper {
	overflow-y: scroll;
	height: calc(100vh - 325px);
	padding-right: 20px;
}

.paramsFormWrapper /deep/ a {
	color: #210f3c !important;
}

.compressedDivider {
	margin-bottom: 0px;
	margin-top: 0px;
}

.paramsFormWrapper /deep/ .customDividerWebhook {
	margin-bottom: 0px;
}

.webhook-radio-group span {
	padding: 12px 13px !important;
}
</style>
